import DOMPurify from "dompurify";

const HTML_ESCAPES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

// Turns text into something the browser shows as text, never as HTML. Use it
// for any value that goes into an HTML string, such as a user's name.
export const escapeHtml = (value: unknown): string =>
  String(value ?? "").replace(/[&<>"']/g, (char) => HTML_ESCAPES[char]);

// Removes scripts, event handlers and dangerous links from HTML, and keeps
// harmless formatting such as <b>. Use it on every string passed to
// dangerouslySetInnerHTML.
export const sanitizeHtml = (html: string): string =>
  DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });

// Returns the address when it is an http or https link, and undefined for
// anything else, such as javascript: addresses. React 18 does not block those.
export const safeExternalUrl = (url?: string | null): string | undefined => {
  const value = url?.trim();
  if (!value) return undefined;

  const withScheme = /^[a-z][a-z0-9+.-]*:/i.test(value) ? value : `https://${value}`;
  try {
    const { protocol } = new URL(withScheme);
    return protocol === "http:" || protocol === "https:" ? withScheme : undefined;
  } catch {
    return undefined;
  }
};
